<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <router-link v-bind:to="'/usuarios/1'" class="btn btn-orange rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>
            <div class="float-end">
              <router-link v-bind:to="'/beneficiarios/' + id_usuario" class="text-muted">
                Beneficiarios <i class="bx bx-chevron-right"></i>
              </router-link>
            </div>
            <br />
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">
                Información básica del usuario
              </h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Nombres <small>(como aparece en la cedula)</small></label>
                  <input v-model="usuario.nombres" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Apellidos <small>(como aparecen en la cedula)</small></label>
                  <input v-model="usuario.apellidos" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>No. de identificación <small>(numero de cedula sin puntos)</small></label>
                  <input v-model="usuario.identificacion" class="form-control" type="text" @keypress="isNumber($event)" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>WhatsApp <small>(numero de whatsapp del usuario, favor confirmar la información)</small></label>
                  <input v-model="usuario.whatsapp" class="form-control" type="text" @keypress="isNumber($event)" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Celular <small>(numero telefonico del usuario, favor confirmar la información)</small></label>
                  <input v-model="usuario.celular" class="form-control" type="text" @keypress="isNumber($event)" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Correo electrónico <small>(correo electrocido de contacto, favor confirmar la
                      información)</small></label>
                  <input v-model="usuario.email" class="form-control" type="text" />
                </div>
                <div class="form-group">
                  <label>Ciudad <small>(ciudad de residencia)</small></label>
                  <v-select v-model="usuario.ciudad" @search="get_ciudades" label="ciudad" :options="ciudades"></v-select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Dirección <small>(dirección de residencia, confirmar esta información)</small></label>
                  <input v-model="usuario.direccion" class="form-control" type="text" />
                </div>
                <!-- <div class="col-lg-12 form-group">
                  <label>Estado</label>
                  <select
                    v-model="usuario.estado_registro"
                    class="form-control"
                  >
                    <option value="0">Interesado</option>
                    <option value="1">Pendiente</option>
                    <option value="3">Exitosa</option>
                  </select>
                </div> -->
                <div class="col-lg-12 text-end">
                  <button v-on:click="update_usuario(1)" class="btn btn-orange btn-lg rounded-pill">
                    <i class="bx bx-save"></i> Guardar y finalizar
                  </button>
                  <button v-on:click="update_usuario(2)" class="btn btn-success rounded-pill ms-1">
                    <i class="bx bx-save"></i> Guardar y continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Usuario_info_basica",
  metaInfo: {
    title: "Usuario - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      id_usuario: null,
      usuario: [],
      ciudades: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    update_usuario: function (step) {
      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.usuario.email);

      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita una dirección de correo electrónico válida.",
        });
        return false;
      }
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        usuario: this.usuario,
      };
      axios
        .post(this.$base_url + "clientes/update_usuario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente",
              text: response.data.message,
            });
          }
          switch (step) {
            case 1:
              vm.$router.push("/");
              break;
            case 2:
              vm.$router.push("/beneficiarios/" + vm.id_usuario);
              break;
          }
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_ciudades: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/ciudades", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.ciudades = response.data.data.ciudades;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 46) {
        evt.preventDefault();
      } else {
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
  },
  mounted: function () { },
};
</script>